import { Box, Link, Image, Text } from "@chakra-ui/react";

function GithubStats() {
  return (
    <Box textAlign={"center"}>
      <Box>
        <Text
          mb={"60px"}
          color={"#FFB6C1"}
          mt={20}
          textDecoration={"underline"}
          fontSize={{ base: "30px", md: "45px", lg: "60px" }}
        >
          Github Stats
        </Text>
      </Box>
      <p display="flex" align="center">
        <Image
        id="github-top-langs"
          mt={"30px"}
          alt="Jha-Vineet69's Top Languages Stats"
          src="https://github-readme-stats.vercel.app/api/top-langs/?username=imrangadwal10&hide=smalltalk&theme=algolia&layout=compact"
          w={{ base: "300px", md: "400px", lg: "500px" }}
        />

        <Link href="https://github.com/imrangadwal10?tab=repositories">
          <Image
           id="github-stats-card"
            mt={"30px"}
            w={{ base: "300px", md: "400px", lg: "500px" }}
            height="auto"
            alt="Imrans's github stats"
            src="https://github-readme-stats.vercel.app/api?username=imrangadwal10&show_icons=true&theme=algolia&count_private=true"
          />
        </Link>

        <Image
         id="github-streak-stats"
          mt={"30px"}
          w={{ base: "300px", md: "400px", lg: "500px" }}
          align="center"
          src="https://github-readme-streak-stats.herokuapp.com/?user=imrangadwal10&hide=smalltalk&theme=algolia&layout=compact"
          alt="imrangadwal10"
        />
      </p>
    </Box>
  );
}

export default GithubStats;
